import React from 'react'

export interface NewPipProps {
  label: string
  className?: string
}

export const NewPip: React.FC<NewPipProps> = ({ label, className }) => {
  const classes = ['new-pip', className].filter(Boolean).join(' ')
  return (
    <span className={classes} aria-label={label}>
      {label}
    </span>
  )
}
